// Svelte
import type { Nullable, RoastChartData, TimeTempPair } from '$lib/types/RoastLog';
import { writable, type Writable } from 'svelte/store';

// UI state
export const sidebarHidden: Writable<boolean> = writable(true);

// This is a resettable factory which isn't persistable.
interface Writeable<T> extends Writable<T> {
  reset(): void;
}
const resetableStoreFactory = <T>(initial: T): Writeable<T> => {
  const { subscribe, set, update } = writable(initial);
  return {
    subscribe,
    set,
    update,
    reset: () => {
      set(initial);
    }
  };
};

export const roastChartDataStore = resetableStoreFactory([
  [],
  null,
  null,
  null,
  []
] as RoastChartData);
export const burnerChartDataStore = resetableStoreFactory([] as TimeTempPair[]);
